 
import Splide from '@splidejs/splide';

const giftGuide = {
    categoryCarousels: function() {
        var categories = document.querySelectorAll('.sp-carousel');

        for (let cat = 0; cat < categories.length; cat++) {
            new Splide(categories[cat], {
				gap: '2rem',
				arrowPath: 'M35,20L5,40L5,0L35,20z',
				throttle: 500,
				speed: 1000,
				classes: {
					arrows: 'splide__arrows carousel-controls',
					arrow: 'splide__arrow carousel-arrow',
					prev: 'splide__arrow--prev carousel-arrow carousel-prev',
					next: 'splide__arrow--next carousel-arrow carousel-next'
				},
				pagination: false,
				start: 0,
				focus: 0,
                padding: {left: '1rem', right: '1rem'},
				perPage: 4,
				perMove: 4,
				breakpoints: {
					1399: {
						type: 'slide',
						perPage: 3,
						perMove: 3
					},
					1123: {
						type: 'slide',
						gap: '2rem',
						perPage: 3,
						perMove: 3
					},
					1023: {
						type: 'slide',
						gap: '2rem',
						perPage: 3,
						perMove: 3
					},
					767: {
						type: 'slide',
						gap: '2rem',
						padding: {left: '1.2rem', right: '1.2rem'},
						perPage: 3,
						perMove: 3
					},
					519: {
						type: 'slide',
						gap: '1.2rem',
						perPage: 2,
						perMove: 1
					}
				}
            }).mount();
        }
    },

    init: function () {
        giftGuide.categoryCarousels();
    }
};

export default giftGuide;